// modules
import { createAction } from 'redux-actions'

// actions

export const setProgramReportList = createAction('SET_PROGRAM_REPORT_LIST')

export const resetProgramReport = createAction('RESET_CASE_MANAGERS_CENSUS')
